/*
 * @Author: Q in
 * @Date: 2026-03-10 09:44:33
 * @LastEditors: Q in 
 * @LastEditTime: 2026-05-20 14:12:05
 * @FilePath: /new_kefu_pc/src/main-admin.js
 * @Description: 客服端入口
 */
import Vue from 'vue';
import App from './App-admin.vue';
import router from '@/router/admin/index.js';
import store from './store';
import { initTheme } from '@/utils/theme';

// 导入消息通知组件
import MessageNotification from '@/utils/messageNotification.js';
// 挂载到 Vue 原型上
Vue.prototype.$messageNotification = MessageNotification;

// 全局样式
import './style/index.scss';
import './style/index.scss';
import './style/global/reset.scss'
import './assets/icon-font/iconfont.css';

// 引入element-ui
import ElementUI from 'element-ui';
import '@/style/theme/admin.css';
Vue.use(ElementUI);

// 自定义主题样式
initTheme('theme4');

Vue.config.productionTip = false;

new Vue({
	router,
	store,
	render: (h) => h(App)
}).$mount('#app');
